import { FEATURES } from "@proj-common/const"
import { planFeatureAvailability } from "@proj-common/enums"
import { IPlan } from "@proj-common/types"

export const BusinessPlan: IPlan = {
    paddleProductData: {
        name: "Business",
        taxCategory: "saas",
        customData: {
            lookup_key: "business",
            type: "plan",
            order: "2",
        },
        type: "standard",
    },
    paddlePriceData: [
        {
            //productId: null, // need to change to actual product ID after creation
            description: "Business Monthly",
            name: "Business Monthly",
            unitPrice: {
                amount: "9000",
                currencyCode: "USD"
            },
            billingCycle: {
                frequency: 1,
                interval: "month",
            },
            quantity: {
                maximum: 1,
                minimum: 1,
            },
            taxMode: "external",
            // trialPeriod: {
            //     frequency: 30,
            //     interval: "day",
            // },
            customData: {
                lookup_key: "business_monthly",
            },
            type: "standard",
        },
        {
            //productId: null, // need to change to actual product ID after creation
            description: "Business Monthly with trial",
            name: "Business Monthly",
            unitPrice: {
                amount: "9000",
                currencyCode: "USD"
            },
            billingCycle: {
                frequency: 1,
                interval: "month",
            },
            quantity: {
                maximum: 1,
                minimum: 1,
            },
            taxMode: "external",
            trialPeriod: {
                frequency: 30,
                interval: "day",
            },
            customData: {
                lookup_key: "business_monthly_trial",
            },
            type: "standard",
        },
        {
            //productId: null, // need to change to actual product ID after creation
            description: "Business Yearly",
            name: "Business Yearly",
            unitPrice: {
                amount: "96000",
                currencyCode: "USD"
            },
            billingCycle: {
                frequency: 1,
                interval: "year",
            },
            quantity: {
                maximum: 1,
                minimum: 1,
            },
            taxMode: "external",
            // trialPeriod: {
            //     frequency: 30,
            //     interval: "day",
            // },
            customData: {
                lookup_key: "business_yearly",
            },
            type: "standard",
        },
        {
            //productId: null, // need to change to actual product ID after creation
            description: "Business Yearly with trial",
            name: "Business Yearly",
            unitPrice: {
                amount: "96000",
                currencyCode: "USD"
            },
            billingCycle: {
                frequency: 1,
                interval: "year",
            },
            quantity: {
                maximum: 1,
                minimum: 1,
            },
            taxMode: "external",
            trialPeriod: {
                frequency: 30,
                interval: "day",
            },
            customData: {
                lookup_key: "business_yearly_trial",
            },
            type: "standard",
        },
    ],
    paddleAddonPriceData: [],
    details: {
        small_text: "For businesses looking for advanced customization and AI-powered facilitation tools.",
        CTA_text: "Get Started",
    },
    features: [
        {
            id: FEATURES.sessions_per_month.id,
            availability: planFeatureAvailability.included,
            description: FEATURES.sessions_per_month.description,
            label: FEATURES.sessions_per_month.label,
            value: 20,
        },
        {
            id: FEATURES.max_participants_per_session.id,
            availability: planFeatureAvailability.included,
            description: FEATURES.max_participants_per_session.description,
            label: FEATURES.max_participants_per_session.label,
            value: 50,
        },
        {
            id: FEATURES.export_basic.id,
            availability: planFeatureAvailability.included,
            description: FEATURES.export_basic.description,
            label: FEATURES.export_basic.label,
        },
        {
            id: FEATURES.export_apps.id,
            availability: planFeatureAvailability.included,
            description: FEATURES.export_apps.description,
            label: FEATURES.export_apps.label,
        },
        {
            id: FEATURES.reporting_html.id,
            availability: planFeatureAvailability.included,
            description: FEATURES.reporting_html.description,
            label: FEATURES.reporting_html.label,
        },
        {
            id: FEATURES.reporting_powerpoint.id,
            availability: planFeatureAvailability.included,
            description: FEATURES.reporting_powerpoint.description,
            label: FEATURES.reporting_powerpoint.label,
        },
        {
            id: FEATURES.ai_ideas_grouping.id,
            availability: planFeatureAvailability.included,
            description: FEATURES.ai_ideas_grouping.description,
            label: FEATURES.ai_ideas_grouping.label,
        },
        {
            id: FEATURES.ai_custom_participants.id,
            availability: planFeatureAvailability.included,
            description: FEATURES.ai_custom_participants.description,
            label: FEATURES.ai_custom_participants.label,
        },
    ]
}